import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=52cc5c52&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"
import style0 from "./Profile.vue?vue&type=style&index=0&id=52cc5c52&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cc5c52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52cc5c52')) {
      api.createRecord('52cc5c52', component.options)
    } else {
      api.reload('52cc5c52', component.options)
    }
    module.hot.accept("./Profile.vue?vue&type=template&id=52cc5c52&scoped=true", function () {
      api.rerender('52cc5c52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/quick/Profile.vue"
export default component.exports